angular.module('workflow.app')

.factory 'Assembler', ( $q ) ->

  # =========================
  # ---- Private methods ----
  # =========================

  createHash = ( array ) ->
    hash = {}
    hash[ item.id ] = item for item in array
    hash

  # @description
  # Links two arrays that has one-to-many relationship.
  # In one-to-many relationship, a foreign record has a property (foreignKey) that is the
  # id of the primary record
  #
  # @param primaryArray An array containing the primary records
  # @param primaryProperty The property on the primary record on which we store the foreign record
  # @param foreignArray An array containing the foreign records
  # @param foreignKey The property on the foreign record that is the id of the primary record
  linkArrayItems = ( primaryArray, primaryProperty, foreignArray, foreignKey ) ->
    primaryHash = createHash( primaryArray )
    for foreignItem in foreignArray
      foreignId = foreignItem[ foreignKey ]
      if foreignId? and primaryHash[ foreignId ]
        primaryItem = primaryHash[ foreignId ]
        primaryItem[ primaryProperty ] = foreignItem

  # @description
  # Links two arrays that has one-to-one relationship.
  # In one-to-one relationship, a primary record has a property (primaryKey) that is the
  # id of the foreign record
  #
  # @param primaryArray An array containing the primary records
  # @param primaryProperty The property on the primary record on which we store the foreign record
  # @param primaryKey The name of the property on the primary record that is the id of the foreign record
  # @param foreignArray An array containing the foreign records
  linkOneToOneArrays = ( primaryArray, primaryProperty, primaryKey, foreignArray ) ->
    foreignHash = createHash( foreignArray )
    for primaryItem in primaryArray
      primaryId = primaryItem[ primaryKey ]
      if primaryId? and foreignHash[ primaryId ]
        foreignItem = foreignHash[ primaryId ]
        primaryItem[ primaryProperty ] = foreignItem

  isAnyUndefined = () ->
    result = false
    for argument in arguments
      isUndefined = not argument?
      result = result or isUndefined
    result

  waitUntilResolved = () ->
    needResolving = ( argument.$promise for argument in arguments when argument.$promise? )
    $q.all( needResolving )

  # =========================
  # ---- Singleton class ----
  # =========================

  new class Assembler

    linkArrayItems: ( primaryArray, primaryProperty, foreignArray, foreignKey ) ->

      if isAnyUndefined( primaryArray, foreignArray )
        return

      waitUntilResolved( primaryArray, foreignArray ).then ()->
        linkArrayItems( primaryArray, primaryProperty, foreignArray, foreignKey )

    linkOneToOneArrays: ( primaryArray, primaryProperty, primaryKey, foreignArray ) ->

      if isAnyUndefined( primaryArray, foreignArray )
        return

      waitUntilResolved( primaryArray, foreignArray ).then ()->
        linkOneToOneArrays( primaryArray, primaryProperty, primaryKey, foreignArray )
